import axios from 'axios';
import { getCurrentUserId } from '../utils/userUtils';


const API_BASE_URL = 'https://plansync-backend-234288438538.us-central1.run.app/api';

// Add this new function to fetch client names
export const fetchClientNames = async (year) => {
    const userid = getCurrentUserId();
    try {
        const response = await axios.get(`${API_BASE_URL}/client_names/${year}`, {
            headers: {
                'user-id': userid
            }
        });
        return response.data.client_names;
    } catch (error) {
        console.error('Error fetching client names:', error);
        throw error;
    }
};


export const sendEmailWithAttachment = async (userId, recipientName, recipientEmail, subject, message, fileName) => {
    try {
        // console.log('Sending email with attachment:', {
        //     userId,
        //     recipientName,
        //     recipientEmail,
        //     subject,
        //     message,
        //     fileName
        // });

        const response = await axios.post(`${API_BASE_URL}/send-file-email/`, {
            user_id: userId,
            file_name: fileName,
            recipient_name: recipientName,
            recipient_email: recipientEmail,
            subject: subject || "Your Requested File",
            message: message || "Please find your requested file attached."
        });

        // console.log('Email sent successfully:', response.data);
        return response.data;
    } catch (error) {
        console.error('Error sending email:', error);
        throw error;
    }
};